import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { format } from 'date-fns'

import { DATE_FORMATS } from 'utils/constants'
import { getDateFormatLocale } from 'utils/getDateFormatLocale'

type Props = {
  rentedFrom: Date | undefined
  rentedTo: Date | undefined
  location: string | undefined
  name: string
}

export const OrderItemHeader: React.FC<Props> = ({ rentedFrom, rentedTo, location, name }) => {
  const { t } = useTranslation('common')

  return (
    <Box marginBottom="12px">
      <Text fontWeight={600} fontSize="xs" marginBottom="3px">
        {name}
      </Text>
      <Text fontSize="xs">
        {t('From')}
        <Text as="span" color="green.a200" fontWeight={600} marginX="2px">
          {rentedFrom && format(rentedFrom, DATE_FORMATS.fullDate, { locale: getDateFormatLocale() })}
        </Text>
      </Text>

      <Text fontSize="xs">
        {t('to')}
        <Text as="span" color="green.a200" fontWeight={600} marginX="2px">
          {rentedTo && format(rentedTo, DATE_FORMATS.fullDate, { locale: getDateFormatLocale() })}
        </Text>
      </Text>

      <Text fontSize="xs">
        {t('in')}
        <Text as="span" color="green.a200" fontWeight={600} marginX="2px">
          {location}
        </Text>
      </Text>
    </Box>
  )
}
